export const PUT_ATTACHMENT = "PUT_ATTACHMENT";
export const REMOVE_ATTACHMENT = "REMOVE_ATTACHMENT";
export const REMOVE_ALL_ATTACHMENTS = "REMOVE_ALL_ATTACHMENTS";
export const POST_THREAD_ATTACHMENTS = "POST_THREAD_ATTACHMENTS";
